export default "__VITE_ASSET__CgVTDSaz__"